export const SCORE_TYPE = Object.freeze({
  TENNIS: "TennisBricks",
  CRICKET: "CricketBricks",
  VOLLEYBALL: "VolleyballBricks",
  UFC: "UFCBricks",
  SURFING: "SurfingBricks",
  GOLF: "GolfBricks",
  RACING: "RacingBricks",
  SKI: "SkiBricks",
  SHOW_JUMPING: "ShowJumpingBricks",
  HORSE_RACING: "HorseRacingBricks",
  POKER: "PokerBricks",
  SKATEBOARDING: "SkateboardingBricks",
  TWO_TEAM: "TwoTeamBricks",
  BADMINTON_AND_TABLE_TENNIS: "BadmintonAndTableTennisBricks",
  SCORING: "ScoringBricks",
  WRESTLING: "WrestlingBricks",
  GOLF_TEAMS: "GolfTeamsBricks",
});
